import { forwardRef, type Ref } from 'react';
import {
  Plus as AddIcon,
  CheckCircle2 as CheckCircleIcon,
  CircleAlert as CircleAlertIcon,
  CircleSlash as CircleSlashIcon,
  FileText as DocumentIcon,
  Frown as FrownIcon,
  Inbox as InboxIcon,
  Loader2 as LoaderIcon,
  LucideProps,
  FolderPlus as NewFolderIcon,
  Building as OrganizationIcon,
  Lightbulb as PromptIcon,
  Search as SearchIcon,
  ListTodo as TaskListIcon,
  User as UserIcon,
  Users as UsersIcon,
} from 'lucide-react';

export {
  AddIcon,
  CheckCircleIcon,
  CircleAlertIcon,
  CircleSlashIcon,
  DocumentIcon,
  FrownIcon,
  InboxIcon,
  LoaderIcon,
  NewFolderIcon,
  OrganizationIcon,
  PromptIcon,
  SearchIcon,
  TaskListIcon,
  UserIcon,
  UsersIcon,
};

export const TeamIcon = forwardRef((props: LucideProps, ref: Ref<SVGSVGElement> | undefined) => {
  return (
    <svg
      ref={ref}
      height="24px"
      version="1.1"
      viewBox="0 0 24 24"
      width="24px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>team</title>
      <g transform="translate(1, 4.2535)" fill="currentColor">
        <path
          d="M12.9366197,7.74647887 C14.7192289,7.74647887 16.1643192,9.19156918 16.1643192,10.9741784 L16.1643192,13.7437968 C16.1643192,14.1003186 15.8753012,14.3893367 15.5187793,14.3893367 C15.1622575,14.3893367 14.8732394,14.1003186 14.8732394,13.7437968 L14.8732394,10.9741784 C14.8732394,9.90461287 14.0061853,9.03755869 12.9366197,9.03755869 L9.06338028,9.03755869 C7.99381475,9.03755869 7.12676056,9.90461287 7.12676056,10.9741784 L7.12676056,13.7437968 C7.12676056,14.1003186 6.8377425,14.3893367 6.48122066,14.3893367 C6.12469881,14.3893367 5.83568075,14.1003186 5.83568075,13.7437968 L5.83568075,10.9741784 C5.83568075,9.19156918 7.28077105,7.74647887 9.06338028,7.74647887 L12.9366197,7.74647887 Z"
          fillRule="nonzero"
        ></path>
        <path
          d="M11,0 C12.7826092,0 14.2276995,1.4450903 14.2276995,3.22769953 C14.2276995,5.01030876 12.7826092,6.45539906 11,6.45539906 C9.21739077,6.45539906 7.77230047,5.01030876 7.77230047,3.22769953 C7.77230047,1.4450903 9.21739077,0 11,0 Z M11,1.29107981 C9.93043446,1.29107981 9.06338028,2.15813399 9.06338028,3.22769953 C9.06338028,4.29726507 9.93043446,5.16431925 11,5.16431925 C12.0695655,5.16431925 12.9366197,4.29726507 12.9366197,3.22769953 C12.9366197,2.15813399 12.0695655,1.29107981 11,1.29107981 Z"
          fillRule="nonzero"
        ></path>
        <path
          d="M18.7723005,10.3286385 C20.5549097,10.3286385 22,11.7737288 22,13.556338 L22,14.8474178 C22,15.2039397 21.7109819,15.4929577 21.3544601,15.4929577 C20.9979382,15.4929577 20.7089202,15.2039397 20.7089202,14.8474178 L20.7089202,13.556338 C20.7089202,12.4867725 19.841866,11.6197183 18.7723005,11.6197183 L15.5545319,11.6197183 C15.2613199,11.6197183 15.2613199,11.2846243 15.2613199,10.965762 C15.2613199,10.6468998 15.2613199,10.3286385 15.5545319,10.3286385 L18.7723005,10.3286385 Z"
          fillRule="nonzero"
        ></path>
        <path
          d="M3.22769953,10.3286385 C1.4450903,10.3286385 0,11.7737288 0,13.556338 L0,14.8474178 C0,15.2039397 0.289018061,15.4929577 0.645539906,15.4929577 C1.00206175,15.4929577 1.29107981,15.2039397 1.29107981,14.8474178 L1.29107981,13.556338 C1.29107981,12.4867725 2.15813399,11.6197183 3.22769953,11.6197183 L6.47123496,11.6197183 C6.73678549,11.6197183 6.76183742,11.3661371 6.76420081,11.0774144 L6.76420081,10.8758008 C6.76183742,10.589683 6.73678549,10.3286385 6.47123496,10.3286385 L3.22769953,10.3286385 Z"
          fillRule="nonzero"
        ></path>
        <path
          d="M17.7652582,2.58215962 C19.5478674,2.58215962 20.9929577,4.02724993 20.9929577,5.80985915 C20.9929577,7.59246838 19.5478674,9.03755869 17.7652582,9.03755869 C15.982649,9.03755869 14.5375587,7.59246838 14.5375587,5.80985915 C14.5375587,4.02724993 15.982649,2.58215962 17.7652582,2.58215962 Z M17.7652582,3.87323944 C16.6956927,3.87323944 15.8286385,4.74029362 15.8286385,5.80985915 C15.8286385,6.87942469 16.6956927,7.74647887 17.7652582,7.74647887 C18.8348238,7.74647887 19.7018779,6.87942469 19.7018779,5.80985915 C19.7018779,4.74029362 18.8348238,3.87323944 17.7652582,3.87323944 Z"
          fillRule="nonzero"
        ></path>
        <path d="M4.23474178,2.58215962 C6.01735101,2.58215962 7.46244131,4.02724993 7.46244131,5.80985915 C7.46244131,7.59246838 6.01735101,9.03755869 4.23474178,9.03755869 C2.45213256,9.03755869 1.00704225,7.59246838 1.00704225,5.80985915 C1.00704225,4.02724993 2.45213256,2.58215962 4.23474178,2.58215962 Z M4.23474178,3.87323944 C3.16517625,3.87323944 2.29812207,4.74029362 2.29812207,5.80985915 C2.29812207,6.87942469 3.16517625,7.74647887 4.23474178,7.74647887 C5.30430732,7.74647887 6.1713615,6.87942469 6.1713615,5.80985915 C6.1713615,4.74029362 5.30430732,3.87323944 4.23474178,3.87323944 Z"></path>
      </g>
    </svg>
  );
});
